import type { SyncHasMany } from "@ember-data/model";
import Model, { attr, hasMany } from "@ember-data/model";
import type ModelRegistry from "@ember-data/types/registries/model";

export default class AdverseEventModel extends Model {
  @hasMany("therapeutical-area", { async: false, inverse: "adverseEvents" })
  declare therapeuticalAreas: SyncHasMany<ModelRegistry["therapeutical-area"]>;
  @attr() type?: "discrete";
  @attr() values?: number[];
}

declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "adverse-event": AdverseEventModel;
  }
}
